// Turn on/off features & tools
type ENV = 'dev' | 'staging' | 'production';

const setting = {
  // DEV
  dev: {
    tools: {
      logger: false,
      defaultCreator: false,
    },
    productivity: {
      map: true,
      thumbnails: true,
      refetchInterval: 5000,
      refetchIntervalLazyLists: 10000,
    },
    features: {
      drivingHoursTracker: true,
      requestDriverAvatar: true,
      videoRecording: true,
      videoStreaming: true,
      alertVideoUpload: true,
      geofence: true,
      report: true,
      userManagement: true,
      groups: true,
      tripDriverAssignment: true,
    },
    setting: {
      notificationSettings: true,
      avatarUploading: true,
    },
    map: {
      routePoints: true,
      routeHistory: true,
    },
  },
  // STAGING
  staging: {
    tools: {
      logger: false,
      defaultCreator: false,
    },
    productivity: {
      map: true,
      thumbnails: true,
      refetchInterval: 5000,
      refetchIntervalLazyLists: 10000,
    },
    features: {
      drivingHoursTracker: true,
      requestDriverAvatar: true,
      videoRecording: true,
      videoStreaming: true,
      alertVideoUpload: true,
      geofence: true,
      report: true,
      userManagement: true,
      groups: true,
      tripDriverAssignment: true,
    },
    setting: {
      notificationSettings: true,
      avatarUploading: true,
    },
    map: {
      routePoints: true,
      routeHistory: true,
    },
  },
  // PRODUCTION
  production: {
    tools: {
      logger: false,
      defaultCreator: false,
    },
    productivity: {
      map: true,
      thumbnails: true,
      refetchInterval: 5000,
      refetchIntervalLazyLists: 10000,
    },
    features: {
      drivingHoursTracker: true,
      requestDriverAvatar: true,
      videoRecording: true,
      videoStreaming: true,
      alertVideoUpload: true,
      geofence: true,
      report: true,
      userManagement: true,
      groups: true,
      tripDriverAssignment: true,
    },
    setting: {
      notificationSettings: true,
      avatarUploading: true,
    },
    map: {
      routePoints: true,
      routeHistory: true,
    },
  },
};

export const FeaturesManagement = setting[process.env.REACT_APP_ENV as ENV || 'production'];

export const BundleVersion = process.env.REACT_APP_BUNDLE_VER || 'unknown';
